<template>
  <!--PPAP-->
  <h-list-page>
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search>
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.mtlNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.mtlNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.sybId" clearable filterable>
            <h-option v-for="(item, index) in sybList" :key="index" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- <h-search title="SQE经理">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search>
        <h-search title="SQE接口人">
          <h-input v-model="searchData.patternPlanId" clearable></h-input>
        </h-search> -->
        <h-search :title="h_i18n('ccc283935d96abaa8e596aae9e7460a7')">
          <h-select v-model="searchData.assessStatus" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable>
            <h-option :key="item.value" :label="item.label" :value="item.value" v-for="item in selfDelayReasonData"></h-option>
            <!-- <h-option :key="1" :label="h_i18n('0cdd8d87bb8a9498fb3038f1dbedb89a')" value="1500"></h-option>
            <h-option :key="2" :label="h_i18n('a273806230179b4d5195ff389352a4b6')" value="1508"></h-option> -->
            <!-- <h-option :key="3" label="SQE接口人审核通过" value="1501"></h-option> -->
            <!-- <h-option :key="4" label="SQE接口人审核打回" value="1502"></h-option> -->
            <!-- <h-option :key="5" :label="h_i18n('0412ae66146f048687481e8a52a91d71')" value="1512"></h-option>
            <h-option :key="6" :label="h_i18n('37364a5eaeeb6d3e71f37db67e3d6240')" value="1540"></h-option> -->
          </h-select>
        </h-search>

        <h-search :title="h_i18n('79b7b25d969728e35f87f7c64e41f646')">
          <h-date-picker @change="dateMapChange('sendDay',dateMap.sendDay)" v-model="dateMap.sendDay" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('36a5d2e23d3454167254f10a406f059d')">
          <h-date-picker @change="dateMapChange('affirmDate',dateMap.affirmDate)" v-model="dateMap.affirmDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('3fdbff5fb33202e37efe7ee12a25a3f2')">
          <h-date-picker @change="dateMapChange('careerConfirmDay',dateMap.careerConfirmDay)" v-model="dateMap.careerConfirmDay" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="loading.table" @click="paginationQuery(1)">
            <template #icon>
              <search/>
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <div style="position: relative;margin-top: 10px;">
      <h-table-card :title="h_i18n('b3b14d334f3fc995b1abe3b8d44e3a5b')" :is-left="1" :h-data="tableDataList" :is-right="1">
        <template #buttonGroup>
          <h-button-group>
            <h-button type="default" :loading="loading.export" @click="derive()" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_ppap_pj_DC')">{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}<template #icon>
                <export/>
              </template>
            </h-button>
            <h-button type="primary" @click="goTOFileDetail" v-if="btnListOfSqm.some(item=>item.code == 'mkhl_ppap_pj_WJQD')">{{ h_i18n('b4df83ecd83bb48345deea3e67527cce') }}</h-button>
          </h-button-group>
        </template>

        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="loading.table" height="540"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small"
                  style="width: 100%;min-height: 540px;">
          <el-table-column :label="h_i18n('a48d8212746f19fa505c68db2f40c09e')" min-width="130">
            <template #default="{row}">
              <div class="blueColor" v-if="row.assessStatus===2250">{{ h_i18n('4a35e03b857bf3cde759bb1390f1bbac') }}</div>
              <div class="blueColor" v-else-if="row.assessStatus===1500">{{ h_i18n('0cdd8d87bb8a9498fb3038f1dbedb89a') }}</div>
              <div class="successColor" v-else-if="row.assessStatus===1508">{{ h_i18n('a273806230179b4d5195ff389352a4b6') }}</div>
              <div class="successColor" v-else-if="row.assessStatus===1501">{{ h_i18n('8d26c107fcadf707adc1de3964879272') }}</div>
              <div class="dangerColor" v-else-if="row.assessStatus===1502">{{ h_i18n('f600bcf6a5f3fae8c785298411bcc066') }}</div>
              <div v-else-if="row.assessStatus===1512">{{ h_i18n('0412ae66146f048687481e8a52a91d71') }}</div>
              <div v-else-if="row.assessStatus===1540">{{ h_i18n('37364a5eaeeb6d3e71f37db67e3d6240') }}</div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop="patternPlanId" :label="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')" width="220"></el-table-column>
          <el-table-column :label="h_i18n('79b7b25d969728e35f87f7c64e41f646')" width="170">
            <template #default="{row}">
              <div>{{ formDate(row.sendDay, 6) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="checkTypeName" :label="h_i18n('6643ded0025cc29815fe4bd5ff7ae566')" min-width="100"></el-table-column>
          <el-table-column prop="patternPlanStatusName" :label="h_i18n('f3fc633edbae2e1c3841d6250db952c3')" width="80"></el-table-column>
          <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="100"></el-table-column>
          <el-table-column prop="mtlName" :label="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" min-width="100"></el-table-column>
          <el-table-column prop="materielCategoryName" :label="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" width="100"></el-table-column>
          <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" min-width="120"></el-table-column>
          <!-- <el-table-column prop="sqeManagerName" label="SQE经理" width="100"></el-table-column>
          <el-table-column prop="sqePortName" label="SQE接口人" width="100"></el-table-column> -->
          <el-table-column prop="affirmDate" :label="h_i18n('36a5d2e23d3454167254f10a406f059d')" width="170">
            <template #default="{row}">
              <div>{{ formDate(row.affirmDate, 6) }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="90">
            <template #default="{row}">
              <span class="h-global-font--blue" @click="lookDetails(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
              <span class="h-global-font--blue" style="margin-left: 8px;" @click="openPPAPProcess(row)">{{ h_i18n('f630b9a4da10f81b7bb1c75bf6345558') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #pagination>
          <el-pagination background @current-change="paginationQuery" v-model:current="pageNation.pageIndex"
                         :page-size="10" layout="total, prev, pager, next,jumper" :total="pageNation.total">
          </el-pagination>
        </template>
      </h-table-card>
    </div>
    <!-- 流程 -->
    <h-dialog :title="h_i18n('ae762b31e735d05f32b0f8aef726da64')" :show="ppapProcessShow" width="70%" @close="ppapProcessClose">
      <el-table :data="ppapProcessList.slice((processPageNo-1)*10,processPageNo*10)"
          v-loading="ppapProcessDialogLoading" border size="small">
          <el-table-column prop="role" :label="h_i18n('8402fcdd8d97edd86fb1bc69059db687')" min-width="100"></el-table-column>
          <el-table-column prop="createDateTime" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170"></el-table-column>
          <el-table-column prop="flagVal" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="100"></el-table-column>
          <el-table-column prop="approveDetail" :label="h_i18n('a6396f13c260444d561afaa9407467be')" width="200"></el-table-column>
        </el-table>
        <el-pagination background @current-change="processCurrentChange" v-model:currentPage="processPageNo"
                     :page-size="10" layout="total, prev, pager, next,jumper" :total="processPageTotal" :hide-on-single-page="processPageTotal <= 10">
      </el-pagination>
    </h-dialog>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


import axios from "axios";
import HOption from "../../../views/Templates/h-hwork/h-option.vue";
import {Export, Loading, LoadingButton, Request} from "../../../Decorator/vue2-decorator";

export default {
  name: "PPAPApplicabilityEvaluationList",
  components: {HOption},
  data() {
    return {
     // 流程参数 -->
     ppapProcessDialogLoading:false,
      ppapProcessShow:false,
      ppapProcessList:[],
      processPageNo:1,
      processPageTotal:0,
      // <--- 流程参数
      selfDelayReasonData:[],// 评价状态
      btnListOfSqm:[],
      searchData: {
        mtlNo: "",
        supplyCode: ""
      },
      loading: {
        export: false,
        table: false
      },
      pageNation: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      http: {
        searchHttp: null,//查询列表--避免重复请求数据覆盖的问题
        mtlSearchHttp: null,//专用号模糊查询
      },

      name: "",
      dateMap: {
        sendDay: null,
        affirmDate: null,
      },
      roleCode: "",//角色
      multipleSelection: [],//选中
      tableDataList: [],//列表
      plan: {showMtlPlan: false},//专用号弹窗
      sybList:[],
    }
  },
  computed: {
    clearAble() {
      let list = Object.keys(this.dateMap)

      let a = list.filter(v => {
        return !!this.dateMap[v];
      })
      return a.length > 1;
    }
  },

  methods: {
    h_i18n,
    // 查询状态表
    getBaseValues () {
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [81],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            if(item.valueTypeId === 81){
              this.selfDelayReasonData.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
    changeMethod() {
      this.postThisPageHeight()
    },
    lookDetails(row) {
      this.$router.push({
        name: "PPAPApplicabilityEvaluationDetail/SQM",
        query: {
          assessId: row.assessId
        }
      })
    },
    // 流程方法 -->
    // 流程查看 ppapProcessShow
    openPPAPProcess(row){
      this.ppapProcessShow = true
      this.ppapProcessDialogLoading = true
      this.ppapProcessList = []
      this.processPageTotal = 0
      if(!row.patternPlanId){
        return
      }
      // 接口 
      this.$http({
        method: "get",
        url: "/base/patternPlan/ppapAssessProcessNodeList?patternPlanId="+row.patternPlanId,
      }).then(res => {
        if(res.data.code === '200'){
          this.ppapProcessList = res.data.data
          this.processPageTotal = res.data.data.length
        }
      }).catch(err=>{
        console.log(err)
        this.ppapProcessList = []
      }).finally(()=>{
        this.ppapProcessDialogLoading = false
      }) 
    },
    // 关闭查看
    ppapProcessClose(){
      this.ppapProcessShow = false
      this.ppapProcessList = []
      this.ppapProcessDialogLoading = false
    },
    // dialog table 翻页
    processCurrentChange (v) {
      this.processPageNo = v
    },
    // <-- 流程方法
    async init() {
      this.name = this.$route.query.name
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName;
      await this.paginationQuery(this.pageNation.pageIndex)
    },
    dateMapChange(item, value) {
      if (value) {
        this.searchData[item + 'Start'] = this.time(value[0], 3)
        this.searchData[item + 'End'] = this.time(value[1], 3)
      } else {
        this.searchData[item + 'Start'] = ""
        this.searchData[item + 'End'] = ""
      }
    },
    authentication(v) {
      if (v === 1) {//模块提交人
        if (["S003", "S009"].includes(this.roleCode)) {
          return true
        } else {
          this.info(h_i18n('4e529cf79d56c438f1d62ff9e3d12377'))
          return false
        }
      } else if (v === 2) {
        if (["S002", "S006", "S000"].includes(this.roleCode)) {
          return true
        } else {
          this.info(h_i18n('4e529cf79d56c438f1d62ff9e3d12377'))
          return false
        }
      }
      // if (roleCode === "S003" || roleCode === "S009") {//模块提交人
      // } else if (roleCode === "S002" || roleCode === "S006" || roleCode === "S000") {//模块批准人
      // } else if (roleCode === "S005" || roleCode === "S008") {//模块无权限人
      // } else if (roleCode === "S001" || roleCode === "S004" || roleCode === "S007" || roleCode === "S010") {//模块浏览人
      // } else if (roleCode === "H002" || roleCode === "H011") {//海尔校核人
      // } else {//海尔浏览人
      // }
    },

    @Loading(h_i18n('d5909c33688b64afc6be256556a9a24c'))
        @LoadingButton("export")
        @Export('PPAP适用性评价.xlsx')
        @Request("vmiService")
    derive() {
      if (this.pageNation.total > 5000) {
        this.info({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: h_i18n('748c802d8fe36ada78520df791295747'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        })
      } else {
        return request({
          method: "post",
          url: "/patternPlan/exportPpapAssessListSqm",
          data: {
            ...this.searchData,
            supplyCode: this.$route.query.name,
            userId: "SUPPLY",
            userName: this.$route.query.nickName
          },
          responseType: "blob",
        })
      }
    },
    formDate(val, len = 3) {
      if (val) {
        return this.time(val, len)
      } else {
        return "-"
      }
    },
    paginationQuery(val) {
      this.pageNation.pageIndex = val;
      if (this.http.searchHttp) {
        this.http.searchHttp.cancel()
        this.http.searchHttp = null
        this.loading.tableListLoading = false;
      }
      this.searchTableList();
    },
    @LoadingButton("table")
    @Request("vmiService")
    searchTableList() {
      let params = {...this.searchData};
      params.userId = "SUPPLY"
      params.supplyCode = this.$route.query.name;
      return request({
        method: "post",
        url: "/patternPlan/ppapAssessListPage",
        data: {
          ...this.pageNation,
          ...params,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          if (res.data.data.records) {
            this.tableDataList = res.data.data.records.map(v => ({...v, loading: false, config: false}));
            this.pageNation.total = res.data.data.total;
          } else {
            this.tableDataList = [];
            this.pageNation.total = 0;
          }
        }
      }).catch((err) => {
        this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') + err)
      });
    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
    myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },
    // 获取工厂小微
    getSybListAdd () {
      this.$http({
        method: "get",
         url: "/base/OqcA/listSyb",
      }).then((res) => {
        this.sybList = res.data.map(item=>{
          return {valueName: item.departmentName,valueId: item.departmentId}
        })
      });
    
    },
    // 打开文件清单页面 PPAPApplicabilityDocumentList/SQM
    goTOFileDetail(){
      this.$router.push({
        name: "PPAPApplicabilityDocumentList/SQM",
        query: {
          name: this.$route.query.name,
          nickName: this.$route.query.nickName
        }
      })
    },    

  },
  mounted() {
    this.getBaseValues()
    this.init()
    this.getSybListAdd()
    if(this.$route.query.parentId && this.$route.query.parentId != 'null' && this.$route.query.parentId != 'undefined' && this.$route.query.parentId != ''){
    let p = this.getButtonFromSqm(this.$route.query.parentId,this.$route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        this.btnListOfSqm = res
      }
    })
    }else{
      this.btnListOfSqm = [
        {code:'mkhl_ppap_pj_WJQD',name:h_i18n('b4df83ecd83bb48345deea3e67527cce')},
        {code:'mkhl_ppap_pj_DC',name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')},
      ]
    }
  },
  activated() {}
};
</script>

<style lang="scss">
.default-box::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.default-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.el-overlay {
  z-index: 1998 !important;
}

.planHidden {
  display: none;
}
</style>

<style lang="scss" scoped>

:deep(.el-table__row) {
  td:last-child {
    .cell {
      overflow: hidden !important;
    }
  }
}

.picture-list {
  height: 500px;
  overflow-y: auto;

  .picture-list-item {
    cursor: pointer;
    display: inline-block;
    padding: 10px;
    max-width: 100%;
    box-sizing: border-box;
  }
}

.picture-list::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;

}

.picture-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: #000;
}

.blueColor {
  color: #2681ff;
}

.dangerColor {
  color: #ff4d4f;
}

.successColor {
  color: #52c41a;
}

.warningColor {
  color: #E6A23C;
}

.pointer {
  cursor: pointer;
}

.item_one {
  padding: 0 !important;
}

tbody {
  .is-left {
    .cell {
      text-align: left !important;
    }
  }
}

.is-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.is-cell:hover {
  white-space: normal;
}

.planHidden {
  display: none;
}

.el-table__row {
  td:last-child {
    .cell {
      overflow: visible;
    }
  }
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #ccc;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}

.default-body {
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;

  .default-body-left {
    width: 200px;
    flex: none;
    display: flex;
    flex-direction: column;
  }

  .default-body-item {
    display: flex;
    height: 50px;
    flex: none;
    align-items: center;
    font-size: 16px;
    color: #6a6a6a;

    :deep(.el-input--prefix) {
      width: 100% !important;
    }

    :deep(.el-input__icon) {
      line-height: 32px;
    }

    :deep(.el-input__inner) {
      padding-left: 34px;
    }

    :deep(.el-input-number) {
      line-height: 31px;
      width: 100%;

      span {
        height: 30px;
      }
    }

    :deep(.el-radio-group) {
      display: flex;
      justify-content: flex-start;

      .el-radio__input {
        display: flex;
        align-items: center;
      }

      .el-radio {
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .el-radio__label {
          font-size: 16px;
        }
      }
    }

    .default-body-picture {
      display: flex;
      font-size: 12px;
      flex-direction: column;
      margin-left: 10px;
    }

  }

  .default-body-textarea {
    display: flex;
    min-height: 50px;
    align-items: center;
  }

  .default-body-title {
    display: flex;
    height: 100px;
    flex: none;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    color: #6a6a6a;
  }

  .default-body-image-list {
    display: flex;
    align-items: center;
    height: 100px;
    flex: none;
    overflow-y: auto;
    flex-direction: column;

    .default-body-image {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #6a6a6a;
      width: 100%;

      .default-body-image-icon {
        width: 14px;
        height: 14px;
        flex: none;
        border-radius: 50%;
      }

      .default-body-image-name {
        width: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
  }


  .default-body-image:hover {
    color: #2681ff;
  }

  .default-body-text {
    height: 20px;
    flex: none;
    color: #ff4d4f;
  }

  .default-body-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>